import React from 'react';
import img4 from '../../assets/logos/img5.png';

import './Modal.css';

const Modal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-body">
          <div className="profile-modal1-left">
            <img src={img4} alt="img4" className="profile-modal1-img" />
          </div>
          <div className="profile-right">
            <div class="cv-section">
              <h2>A Company for you LLC</h2>

              <p>Creamos su sociedad en el extranjero</p>
              <p>Constituya con nosotros su LLC o Compañía y proteja su patrimonio evitando sorpresas y disgustos en el futuro.</p>
              <p>Nuestro Estudio cumple con los mayores estándares profesionales de ética, responsabilidad y compromiso, teniendo como fin principal la constitución de “vehículos de inversión y/u operativos” adecuados a sus fines y objetivos.</p>

              <h3>¿Qué procedimientos facilitamos específicamente?</h3>
              <ul>
                <li>Asesoramiento legal en la constitución de las Compañías y/o LLC.</li>
                <li>Alianzas con Empresas Extranjeras de Inversión de gran trayectoria y respaldo en el mercado.</li>
                <li>Apoyo contable en el exterior mediante un servicio tercerizado opcional.</li>
                <li>Apertura de Cuentas Bancarias.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
